import React, { createContext, useContext } from "react";
import { useTournament } from "./useTournament";

const TournamentContext = createContext<ReturnType<
  typeof useTournament
> | null>(null);

export const TournamentProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const Tournament = useTournament();
  return (
    <TournamentContext.Provider value={Tournament}>
      {children}
    </TournamentContext.Provider>
  );
};

export const useTournamentContext = () => {
  const context = useContext(TournamentContext);
  if (!context) {
    throw new Error("error");
  }
  return context;
};
